<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Search</h4>
</div>

<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="mvd_form-group">
        <vehicle-search-bar [label]="'Vehicle Search'" [required]="true" (onItemSelected)="vehicleSelected($event)"></vehicle-search-bar>
    </div>
</div>